module.exports = __webpack_public_path__ + "img/UTESCA-4.f63817a6.jpg";